import React, { useState } from "react";
import axios from "axios";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import {
  Container,
  Typography,
  Breadcrumbs,
  Link,
  Box,
  Paper,
  Button,
} from "@mui/material";
import { postApi } from "../../ApiServices/api";
import { apiEndPoints } from "../../ApiServices/config";
import { useNavigate } from "react-router-dom";

const PayPalPaymentPage = ({ orderID }) => {
  const navigate = useNavigate();
  // 1️⃣ Create Order when the PayPal button is clicked

  // 2️⃣ Capture Payment when the user approves it
  const captureOrder = async (actions) => {
    try {
      const response = await postApi(
        apiEndPoints.payPalCaptureOrder.replace(":id", orderID)
      );
      if (response?.data.status == "COMPLETED") {
        navigate("/payment?success=true");
      }
    } catch (error) {
      console.error(error);
    }
  };
  const initialOptions = {
    "client-id": process.env.REACT_APP_PAYPAL_CLIENT_ID,
    "enable-funding": "venmo",
    "buyer-country": "US",
    currency: "USD",
    components: "buttons",
  };

  return (
    <Container>
      {/* Page Header */}
      <Box sx={{ bgcolor: "#f5f5f5", py: 3, textAlign: "center", mb: 4 }}>
        <Typography variant="h4">Proceed to Pay</Typography>
      </Box>

      {/* Breadcrumbs */}
      <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 3 }}>
        <Link underline="hover" color="inherit" href="/">
          Home
        </Link>
        <Typography color="text.primary">Payment</Typography>
      </Breadcrumbs>

      {/* Payment Section */}
      <Box display="flex" justifyContent="center">
        <Paper
          elevation={3}
          sx={{ p: 3, width: "100%", maxWidth: 400, textAlign: "center" }}
        >
          <Typography variant="h6" gutterBottom>
            Payment Details
          </Typography>
          <img
            src="/assets/img/card_stripe.jpg"
            alt="Payment Methods"
            width="100%"
            style={{ marginBottom: 15 }}
          />

          {/* PayPal Buttons */}
          <PayPalScriptProvider options={initialOptions}>
            <PayPalButtons
              style={{
                shape: "rect",
                layout: "vertical",
                color: "gold",
                label: "paypal",
              }}
              createOrder={() => {
                return orderID;
              }}
              onApprove={captureOrder}
            />
          </PayPalScriptProvider>
        </Paper>
      </Box>
    </Container>
  );
};

export default PayPalPaymentPage;
